// extracted by mini-css-extract-plugin
export default {"input":"Input_input__yfitf","default":"Input_default__tmUKp","small":"Input_small__GUQ0G","large":"Input_large__tn-wm"};